// you can type rafce to get template
import React from 'react'
import './about.css'
import GitHubCalendar from 'react-github-calendar';


const Gitt = () => {
  return (
    <section id='gitt' class="gitt" >
      <h5>More Details of my</h5>
      <h2>Github</h2>
      <div className="container about__container">
        <div className="about__content">
          
          <h3 align="left">Languages and Tools:</h3>
{/* <p align="left" id="github-top-langs" data-testid="github-top-langs"> 
  <a href="https://www.w3.org/html/" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" alt="html5" width="40" height="40"/> </a>
  <a href="https://www.w3schools.com/css/" target="_blank" rel="noreferrer"><img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" alt="css3" width="40" height="40"/> </a> 
  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" alt="javascript" width="40" height="40"/> </a>
  <a href="https://reactjs.org/" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" alt="react" width="40" height="40"/> </a>
  <a href="https://expressjs.com" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg" alt="express" width="40" height="40"/> </a>
  <a href="https://git-scm.com/" target="_blank" rel="noreferrer"> <img src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg" alt="git" width="40" height="40"/> </a>
  <a href="https://www.mongodb.com/" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" alt="mongodb" width="40" height="40"/> </a>
  <a href="https://nodejs.org" target="_blank" rel="noreferrer"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg" alt="nodejs" width="40" height="40"/> </a>
  <a href="https://postman.com" target="_blank" rel="noreferrer"> <img src="https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" alt="postman" width="40" height="40"/> </a>  
</p> */}
<div id="gitstats">
<img
          id="github-top-langs"
          // style="margin-top: 50px"
          
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=syed2605&color=green&theme=dark"
          alt="syed2605"
        />
</div>
<div id="gitstats" class="grd"><p>&nbsp;<img align="center" src="https://github-readme-stats.vercel.app/api?username=syed2605&show_icons=true&locale=en&color=green&theme=dark" alt="syed2605" id="github-stats-card"  /></p>

<p><img align="left" src="https://github-readme-streak-stats.herokuapp.com/?user=syed2605&color=green&theme=dark" alt="syed2605" id="github-streak-stats" /></p></div>
<div  id="gitstats">

  {/* <img src="https://ghchart.rshah.org/syed2605?width=760&height=100&color=green" alt="Your GitHub Contribution Graph" className="react-activity-calendar" width="100%" /> */}
  <GitHubCalendar username="syed2605" class="react-activity-calendar" style={{background:"none"}} />
  </div>
        </div>
      </div>
    </section>
  )
}

export default Gitt